import './App.css';
import ModularConstruction from './componants/r1';

function App() {
  return (
    <div className="App">
      <ModularConstruction />
    </div>
  );
}

export default App;
